export default {
  getDocumentLink: (state) => state.documentLink,
};
